import ENDPOINT from "@/api/endpoints";
import { HTTP, HTTP_HSLT, buildQueries } from "@/api/http-common";

export function callAPiLayDanhSachVanBan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.VAN_BAN}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTaoVanBan(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiCapNhatVanBan(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiXoaVanBan(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN,
    method: "DELETE",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetDanhSachLoaiVanBan() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.VAN_BAN.LOAI_SO.GET_LOAI_VAN_BAN)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTaoLoaiSoVanBan(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN.LOAI_SO.THEM_LOAI_SO,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiSuaLoaiSoVanBan(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN.LOAI_SO.SUA_LOAI_SO,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiXoaLoaiSoVanBan(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN.LOAI_SO.XOA_LOAI_SO}/${payload}`,
    method: "DELETE",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetDanhSachLoaiSoVanBanPaging(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN.LOAI_SO.GET_DANH_SACH_LOAI_SO_PAGING}?${buildQueries(
        payload
      )}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDanhSachLoaiSoVanBan() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.VAN_BAN.LOAI_SO.GET_DANH_SACH_LOAI_SO)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLoadOptionDonVi() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.VAN_BAN.SO_VAN_BAN.OPTION_DON_VI)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDanhSachSoVanBanPaging(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN.SO_VAN_BAN.DANH_SACH_SO_PAGING}?${buildQueries(
        payload
      )}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}



export function callApiTaoSoVanBan(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN.SO_VAN_BAN.THEM_SO,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiSuaSoVanBan(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN.SO_VAN_BAN.SUA_SO,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiXoaSoVanBan(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN.SO_VAN_BAN.XOA_SO + "/" + payload,
    method: "DELETE",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetDanhSachLoaiVanBanPaging(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.LOAI_VAN_BAN.GET_ALL}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTaoLoaiVanBan(payload) {
  return HTTP({
    url: ENDPOINT.LOAI_VAN_BAN.THEM,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiSuaLoaiVanBan(payload) {
  return HTTP({
    url: ENDPOINT.LOAI_VAN_BAN.SUA,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiXoaLoaiVanBan(payload) {
  return HTTP({
    url: `${ENDPOINT.LOAI_VAN_BAN.XOA}?${buildQueries(payload)}`,
    method: "DELETE",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetAllLoaiVanBan() {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.LOAI_VAN_BAN.GET_ALL_VAN_BAN}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDanhSachLoaiVanBanMacDinh() {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.LOAI_VAN_BAN.GET_ALL_VAN_BAN_MAC_DINH}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function callApiGetChiTietLoaiVanBan(payload) {
  return HTTP({
    url: `${ENDPOINT.LOAI_VAN_BAN.CHI_TIET_LOAI_VAN_BAN}?${buildQueries(payload)}`,
    method: "GET",
    data: payload
  });
}

export function callApiTimKiemVanBan(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.TIM_KIEM,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiUpdateDsVanBanLienQuan(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.UPDATE_DS_VAN_BAN,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiTraCuuLayLaiVanBan(id) {
  return HTTP({
    url: ENDPOINT.VAN_BAN.TRA_CUU_LAY_LAI_VAN_BAN(id),
    method: "POST",
    asyncLoading: true,
  })
}

export function callApiSaoChepVanBan(id) {
  return HTTP({
    url: ENDPOINT.VAN_BAN.SAO_CHEP_SO(id),
    method: "POST",
    //data: payload,
    asyncLoading: true,
  });
}

export function callApiGetDanhSachTaiLieuHoSo(payload) {
  return HTTP_HSLT({
    url: `${ENDPOINT.VAN_BAN.GET_DANH_SACH_TAI_LIEU_HO_SO}?${buildQueries(payload)}`,
    method: "GET",
    data: payload
  });
}

export function callApiThemTaiLieuVaoHoSoLuuTru(payload) {
  return HTTP_HSLT({
    url: ENDPOINT.VAN_BAN.THEM_TAI_LIEU_VAO_HO_SO,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiThemCongViecVaoHoSoLuuTru(payload) {
  return HTTP_HSLT({
    url: ENDPOINT.VAN_BAN.THEM_CONG_VIEC_VAO_HO_SO,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}
